import styled from 'styled-components';

export const QueryWrapper = styled.div`
  padding: 1.5rem 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: calc(100vh - 100px);

  @media (max-width: 768px) {
    padding: 1rem 0;
    min-height: calc(100vh - 80px);
  }
`;

export const QueryContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  height: calc(100vh - 140px);
  max-height: 900px;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 1200px) {
    height: calc(100vh - 120px);
    max-height: 800px;
  }

  @media (max-width: 768px) {
    height: calc(100vh - 100px);
    max-height: none;
    border-radius: 0.375rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 576px) {
    height: calc(100vh - 90px);
    border-radius: 0.25rem;
  }
`;